import React from 'react';
import ReactPaginate from 'react-paginate';

import { PER_PAGE } from 'app/constants';

class PaginationComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  handlePageChange = (data) => {
    const page = data.selected + 1;
    this.props.onPageChange(page);
  };

  render() {
    const { page, totalItemsCount } = this.props;

    if (totalItemsCount <= PER_PAGE) {
      return null;
    }

    return (
      <ReactPaginate
        pageCount={Math.ceil(totalItemsCount / PER_PAGE)}
        pageRangeDisplayed={5}
        marginPagesDisplayed={2}
        onPageChange={this.handlePageChange}
        forcePage={page - 1}
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
        disabledClassName="disabled"
        previousLabel={<span aria-hidden="true">&laquo;</span>}
        nextLabel={<span aria-hidden="true">&raquo;</span>}
        breakLabel="..."
      />
    );
  }
}

export default PaginationComponent;
